<template>
  <div>
    <div class="w-full pb-4 xl:pb-6">
      <Navigation :step="2" />

      <div v-if="!redemptionUltimateFailureReason" class="w-full viewport-gutter">
        <div class="container">
          <div class="text-sm xl:text-lg">
            <h1 class="text-lg font-bold leading-tight pb-2 xl:text-4xl">
              {{ $t('pages.redemption.title') }}
            </h1>
            <p v-if="!loading || errors.length" class="leading-tight">
              {{ $t('pages.redemption.subtitle') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="redemptionUltimateFailureReason" class="bg-gray-100">
      <p class="max-w-sm mx-auto text-center pt-6 xl:pt-12">
        {{ $t(`errors.type.${errors[0]}.title`, brandInfo) }}
        <br>
        {{ $t(`errors.type.${errors[0]}.description`, brandInfo) }}
      </p>
      <p class="max-w-sm mx-auto text-center pt-2">
        {{ $t('components.payment.beforeCancellationRedirect', brandInfo) }}
      </p>
    </Loading>

    <div v-else-if="redemption.id" class="w-full pt-6 pb-16 bg-gray-100 border-t border-b border-gray-200 flex-1-0-auto viewport-gutter xl:pt-8">
      <div class="container">
        <div class="w-full max-w-xl m-0">
          <RouterView />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Redemption from '~psp-pages/base/redemption/redemption.ts'

import Navigation from '~app/psp/lufthansa/navigation.vue'
import Summary from './summary.vue'
import Loading from '~brand-components/lufthansa/loading/loading.vue'

export default Redemption.extend({
  components: {
    Navigation,
    Summary,
    Loading,
  },
})
</script>
